import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";
import { fmtDur } from "./format";

const Stat = ({ value, label, cls = "", testid }) => (
  <div className="border border-border rounded-sm p-3">
    <div className={`text-2xl font-condensed font-extrabold ${cls}`} data-testid={testid}>{value}</div>
    <div className="text-[11px] uppercase tracking-wide text-muted-foreground">{label}</div>
  </div>
);

export function TimeTodayTile() {
  const [today, setToday] = useState(null);
  const load = useCallback(() => api.get("/time/today").then((r) => setToday(r.data)).catch((e) => console.error("time today", e)), []);
  useEffect(() => { load(); const t = setInterval(load, 30000); return () => clearInterval(t); }, [load]);
  return (
    <div className="border border-border bg-card rounded-sm p-4 mb-6" data-testid="time-tile">
      <div className="flex items-center gap-2 mb-3">
        <Clock className="h-4 w-4 text-primary" />
        <span className="text-sm font-semibold">Time — Today</span>
        <span className="text-xs text-muted-foreground">· {today?.day || ""}</span>
        <span className="ml-auto flex items-center gap-1.5 text-xs">
          <span className="relative flex h-2.5 w-2.5"><span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75" /><span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" /></span>
          <span className="font-semibold" data-testid="on-clock-count">{today?.on_clock_count || 0}</span> on the clock
        </span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-3">
        <Stat value={fmtDur(today?.clocked_seconds)} label="Total Clocked" testid="today-clocked" />
        <Stat value={fmtDur(today?.active_seconds)} label="Active" cls="text-emerald-600" />
        <Stat value={today?.people || 0} label="People" />
        <Stat value={today?.shifts || 0} label="Shifts" />
      </div>
      {today?.on_clock?.length ? (
        <div className="flex flex-wrap gap-2" data-testid="on-clock-list">
          {today.on_clock.map((c) => (
            <span key={`${c.user_name}-${c.department}`} className="inline-flex items-center gap-1.5 text-xs border border-border rounded-sm px-2.5 py-1">
              <span className={`h-1.5 w-1.5 rounded-full ${c.stale ? "bg-amber-400" : "bg-emerald-500"}`} />
              {c.user_name} <span className="text-muted-foreground">· {fmtDur(c.total_seconds)}</span>
            </span>
          ))}
        </div>
      ) : <p className="text-xs text-muted-foreground">No one is clocked in right now.</p>}
    </div>
  );
}
